class SidebarNavigation {
    init() {
        this.articles = document.querySelectorAll('.nav-container');
        this.navItems = document.querySelectorAll('.content-nav_item');

        this.initObserver();
    }

    initObserver() {
        const options = {
            root: null,
            threshold: 0,
            rootMargin: '0px 0px -90% 0px',
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.navItems.forEach(navItem => {
                        if (navItem.hash === '#' + entry.target.id) {
                            navItem.classList.add('active');
                        } else {
                            navItem.classList.remove('active');
                        }
                    });
                }
            });
        }, options);

        this.articles.forEach(article => observer.observe(article));
    }

    convertHeading(entry) {
        const heading = entry.target.querySelector('.heading');
        const headingText = heading.innerHTML.toLowerCase()
            .replace(/&amp;/g, "&")
            .replace(/&lt;/g, "<")
            .replace(/&gt;/g, ">")
            .replace(/&#39;/g, "'")
            .replace(/&quot;/g, '"');

        return headingText;
    }
}

export default new SidebarNavigation();
